import React from 'react';

const ZoomControls = ({zoomPercent, onZoomIn, onZoomOut, onReset}) => (
  <div
    className="absolute top-2 right-2 z-10 flex items-center gap-2 select-none"
    data-test="zoom-controls"
  >
    <button
      type="button"
      className="bg-black/60 text-white rounded px-2 py-1 text-sm hover:bg-black/80"
      data-test="zoom-out-button"
      onClick={onZoomOut}
    >−</button>
    <div
      className="bg-black/60 text-white rounded px-3 py-1 text-sm font-mono"
      data-test="zoom-percent"
    >{zoomPercent}%</div>
    <button
      type="button"
      className="bg-black/60 text-white rounded px-2 py-1 text-sm hover:bg-black/80"
      data-test="zoom-in-button"
      onClick={onZoomIn}
    >+</button>
    <button
      type="button"
      className="bg-black/60 text-white rounded px-2 py-1 text-sm hover:bg-black/80"
      data-test="zoom-reset-button"
      onClick={onReset}
    >⤾</button>
  </div>
);

export default ZoomControls;
